import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import SnackNotifier from 'common/components/SnackNotifier';
import React from 'react';

import AppInitializer from './AppInitializer';
import AppRoutes from './AppRoutes';
import Nav from './Nav';

const App: React.FC = () => {
  return (
    <>
      <CssBaseline />
      <Nav />
      <AppInitializer />
      <Container maxWidth="lg" sx={{ paddingTop: 3 }}>
        <Box height={'calc(100vh - 92px)'}>
          <SnackNotifier />
          <AppRoutes />
        </Box>
      </Container>
    </>
  );
};

export default App;
